import classNames from "classnames";
import Popover from "component/design-system/popover/Popover";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import HideIf from "util/HideIf";
import styles from "./productTags.module.scss";

export function tagColorMap(tagValue: string): string {
  const tagsValue = {
    "Standard/OE": "standard_oe",
    "Daily Driver": "daily_driver",
    Economy: "economy",
    "Economy Driver": "economy_driver",
    Économique: "economy_driver",
    Premium: "premium",
    "Première qualité": "premium",
    "Spirited Driver": "spirited_driver",
    "High-Performance": "high_performance",
    "High Performance": "highperformance",
    "Haute Performance": "high_performance",
    "Performance Driver": "performance_driver",
  };

  return tagsValue[tagValue] || "default";
}

interface IProps {
    tagValue: string,
    desc: string;
    circular?: boolean
}

function RenderTag(props: IProps) {
  const { tagValue, desc, circular = false } = props;

  const updatedTagValue = tagValue.replace("Grade", "").trim();

  const colorStyles = updatedTagValue ? styles[tagColorMap(updatedTagValue)] : styles.default;

  return (
    <div className={classNames(colorStyles, {
      [styles.note]: !circular,
      [styles.circular]: circular,
    })}
    >
      <HideIf show={desc}>
        <Popover
          placement="bottom-start"
          component={(
            <div className={styles.popover_style}>
              {desc}
            </div>
          )}
        >
          <div className="tag-bg">
            <PAText fontSize={FONT_SIZE[0]} className={styles.tag_Text}>{tagValue}</PAText>
          </div>
        </Popover>

      </HideIf>
      <HideIf show={!desc}>
        <div className={`tag-bg ${styles.tag_label}`}>
          <PAText fontSize={FONT_SIZE[0]} className={styles.tag_Text}>{tagValue}</PAText>
        </div>
      </HideIf>
    </div>
  );
}

export default RenderTag;
